<template>
    <div>
        <flex-row @click="touch()" gap>
            <flex-cell vcenter shrink>
                <ux-checkbox :value="boolean" @click="boolean = !boolean" />
            </flex-cell>
            <flex-cell vcenter>
                <div>
                    <label class="ux-field-title" v-if="showLabel">
                        {{label}} <span class="ux-required-marker" v-if="required">*</span>
                    </label>
                    <div class="ux-field-description" v-if="showDescription">{{description}}</div>
                </div>
            </flex-cell>
        </flex-row>
    </div>
</template>
<script>
import InputMixin from './input-mixin';
import NativeCheckbox from '../../ui/checkbox.vue';


function getBooleanFromPossibleArray(v) {
    if(Array.isArray(v)) {
        return !!v[0];
    } else {
        return !!v;
    }
}

export default {
    mixins: [InputMixin],
    components: {
        UxCheckbox:NativeCheckbox,
    },
    props: {
        modelValue: {
            type: [Boolean, Array],
        },
    },
    data() {
        return {
            boolean: getBooleanFromPossibleArray(this.modelValue),
        }
    },
    watch: {
        modelValue(val, old) {
            this.boolean = getBooleanFromPossibleArray(val);
        },
        boolean(newVal, oldVal) {
            if (this.multiValue) {
                this.$emit('update:modelValue', [newVal]);
            } else {
                this.$emit('update:modelValue', newVal);
            }
        }
    },
    methods:{
        getNewDefaultEntry() {
            return !!this.boolean;
        },
    },
    computed: {
        longDescription() {
            return String(this.description).length > 2;
        },
    }
}
</script>
